import React from "react"
import Image from "../components/image"
import CovidChart from "../components/covid-chart"

export default function CovidHero() {
  return (
    <section className="covid-hero">
      <h1>
        A <br></br> Crisis<br></br> Like <br></br> No<br></br> Other
      </h1>

      <div className="covid-hero__container">
        <CovidChart />
        <div className="covid-hero__label">
          <h3 className="title--tertiary title--uppercase">World GDP Growth</h3>
          <p className="title--meta title--light title--uppercase">
            Quarterly Percentage Change
          </p>
        </div>
      </div>
      <Image
        path="spotlights/covid-19/covid-hero.jpg"
        className="util__fill util__image-fill"
      />
    </section>
  )
}
